// extracted by mini-css-extract-plugin
export default {"back-style":"Loading_back-style__pGUlF"};